module.exports = __webpack_public_path__ + "tables/media/account.83542cf8.svg";